import { getApiBaseUrl } from "../../utils/apiBaseUrl";

export const RemoveFromFavouritesAsync = async (
    addressId: number,
    token: string
  ): Promise<any> => {
    const baseUrl = getApiBaseUrl();
    const apiUrl = `${baseUrl}/api/AddressFavourites/RemoveFromFavouritesAsync?addressId=${addressId}`;
  
    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        throw new Error(`Failed to remove from favourites: ${response.statusText}`);
      }
  
      return response.json();
    } catch (error) {
      // console.error('Error in RemoveFromFavouritesAsync:', error);
      throw error;
    }
  };
  